import { EndpointConfig, SiteConfig } from 'top-context';
import { Boolean, Record, Static } from 'runtypes';

export interface SettingsState {
  appName: string;
  endpointConfig: EndpointConfig;
  siteConfig: SiteConfig;
  activeModules: ActiveModules;
}

export const ActiveModules = Record({
  claims: Boolean,
});

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ActiveModules = Static<typeof ActiveModules>;
